import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (import.meta.client) return;

    const nuxtApp = useNuxtApp();
    const i18n = nuxtApp.$i18n;
    if (!i18n) return;

    const locales = Array.isArray(i18n.locales) ? i18n.locales : i18n.locales?.value;

    if (!Array.isArray(locales)) return;

    const path = to.path;

    // Sort locales by code length descending (longest first)
    const sortedLocales = [...locales].sort((a, b) => b.code.length - a.code.length);

    for (const { code } of sortedLocales) {
        const localeRegex = new RegExp(`^/${code}($|/)`);

        if (path.startsWith(`/${code}`)) {
            if (!localeRegex.test(path)) {
                throw createError({
                    statusCode: 404,
                    statusMessage: 'Page not found',
                });
            }
            // Path matched a locale correctly so stop checking further
            break;
        }
    }
});
